/**
 * Scroll position restoration.
 *
 * Fix: clicking into a product page and then hitting the browser Back
 * button was returning the shopper to the top of the previous page
 * instead of where they were scrolled to when they clicked the product.
 *
 * How it works:
 * 1. We take control of scroll restoration away from the browser
 *    (history.scrollRestoration = 'manual'), since the theme's dynamic
 *    content (lazy-loaded images, AJAX-rendered collection grids, third
 *    party app scripts, etc.) can make the browser's automatic
 *    restoration unreliable.
 * 2. While the shopper scrolls, we save their scroll position to
 *    sessionStorage, keyed by the current URL.
 * 3. When a page loads (including via Back/Forward navigation), we
 *    restore the saved scroll position for that URL, if one exists.
 */
(function () {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  var STORAGE_PREFIX = 'scrollpos:';

  function getKey() {
    return STORAGE_PREFIX + window.location.pathname + window.location.search;
  }

  function saveScrollPosition() {
    try {
      sessionStorage.setItem(getKey(), String(window.scrollY));
    } catch (e) {
      // sessionStorage may be unavailable (private browsing, etc.) - fail silently.
    }
  }

  function restoreScrollPosition() {
    try {
      var saved = sessionStorage.getItem(getKey());
      if (saved !== null) {
        window.scrollTo(0, parseInt(saved, 10));
      }
    } catch (e) {
      // ignore
    }
  }

  // Keep a fairly fresh save of the scroll position while the shopper
  // browses, in addition to saving right before they navigate away.
  var saveTimeout;
  window.addEventListener(
    'scroll',
    function () {
      clearTimeout(saveTimeout);
      saveTimeout = setTimeout(saveScrollPosition, 200);
    },
    { passive: true }
  );

  window.addEventListener('pagehide', saveScrollPosition);
  window.addEventListener('beforeunload', saveScrollPosition);

  // 'pageshow' fires on normal loads AND on Back/Forward navigation,
  // including when the page is served from the browser's cache.
  window.addEventListener('pageshow', restoreScrollPosition);
})();
